import React, { useEffect, useState } from "react";
import InnerBanner from "../../components/common/InnerBanner";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { checkDiscount, checkDiscountNonLogin, checkPrice, createNewOrder, setAnalysisArray, setSelectedDiscount } from "../../redux/reducers/createOrderSlice";
import { toast } from "react-toastify";
import { getPriceFormatted } from "../../utils/getPriceFormatted";
import SignupComp from "./SignupComp";
import AddressComp from "./AddressComp";
import { pushProfilePhotoToS3 } from "../../services/api/ordersApis";
import ProfessionalBanner from "../../components/common/ProfessionalBanner";

const CheckOut = () => {
  const navigate = useNavigate()
  const { professionalServiceAllFiles,
    professionalServiceAllFilesForUiShow,
    selectedDiscount,
    selectedPreferredStaff,
    numberOfsessions,
    selectedCategory,
    selectedEndDate,
    selectedStartDate,
    regularServiceArrays,
    selectedService,
    selectedDuration,
    priceDetails,
    selectedAddress,
    additionalComments,
    recurrenceRule,
    selectedProfServiceArray,
    preferredDates,
    analysisArray,
    serviceTypes,
    secondaryStaff
  } = useSelector((state) => state.createOrderSlice)
  const { user } = useSelector((state) => state.auth)
  const dispatch = useDispatch()
  const [discount, setDiscount] = useState(selectedDiscount?.discountCode ?? "");


  const checkDiscountCode = () => {
    if (user) {
      dispatch(
        checkDiscount({
          values: {
            code: discount,
            createdFor: user?._id
          },
        })
      );
    }
    else {
      dispatch(
        checkDiscountNonLogin({
          values: {
            code: discount,
            // createdFor: user?._id
          },
        })
      );
      // toast.error("Please sign in first")
    }


  };

  const getServiceSummary = (analysisData) => {
    let serviceSummaryArray = []
    for (const cat of analysisData) {
      if (cat?.subcats?.length) {
        serviceSummaryArray.push({
          "name": cat?.name,
          "type": 'category',
          "price": cat?.price,
          "categoryId": cat?.id
        })
        for (const subCats of cat?.subcats) {
          serviceSummaryArray.push({
            "name": subCats?.name,
            "type": 'sub-category',
            "price": subCats?.price,
            "subCategoryId": subCats?.id,
            "categoryId": cat?.id
          })
          for (const service of subCats?.services) {
            serviceSummaryArray.push({
              "name": service?.name,
              "type": 'service',
              "price": service?.price,
              "serviceId": service?.id,
              "subCategoryId": subCats?.id,
              "categoryId": cat?.id
            })
          }
        }
      }
      else {
        serviceSummaryArray.push({
          "name": cat?.serviceName,
          "type": 'service',
          "price": cat?.price,
          "serviceId": cat?.serviceId,
          "categoryId": cat?.id
        })
        serviceSummaryArray.push({
          "name": cat?.name,
          "type": 'category',
          "price": cat?.price,
          "categoryId": cat?.id
        })
      }
    }
    return serviceSummaryArray
  }
  const createOrder = async (unitNo, addressName) => {
    if (selectedCategory?.toLowerCase() === "general") {
      if (priceDetails) {
        let bodyData = {
          createdFor: user?._id,
          location: {
            type: "point",
            coordinates: selectedAddress?.location?.coordinates,
          },
          orderType: selectedCategory,
          address: {
            generalLocation: selectedAddress?.generalLocation,
            postalCode: selectedAddress?.postalCode,
            displayAddress: selectedAddress
          },
          formatedAddress: `${selectedAddress?.address?.replace('Singapore', '')}`,
          additionalMessage: additionalComments ?? "",
          sessions: 1,
          discountId: selectedDiscount?.discountId ?? "",
          discountCode: selectedDiscount?.discountCode ?? "",
          TransactionFee: 0,
          svcStartDate: selectedStartDate,
          svcEndDate: selectedEndDate,
          unitNo: selectedAddress?.unitNo ?? "",
          serviceArray: selectedService?.map((item, index) => {
            return {
              serviceId: item?._id,
              duration: selectedDuration,
              position: index + 1,
              staff: "",
              startDate: selectedStartDate,
              endDate: selectedEndDate,
              daysSelected: recurrenceRule?.days,
              selectedFrequency: recurrenceRule?.frequency,
              selectedTimePrefence: recurrenceRule?.timePreference
            };
          }),
          isAllowForNightService:
            recurrenceRule?.timePreference?.includes("Night"),
          recurenceRule: recurrenceRule,
          serviceDescription: priceDetails?.servicePriceArray?.map(item => `General ${item.duration} Hour`),
          serviceSummary: getServiceSummary(analysisArray)
        };
        dispatch(createNewOrder({ values: bodyData, dispatch: dispatch, navigate: navigate, user: user }));
      }
    }
    else if (selectedCategory?.toLowerCase() === "regular") {
      if (priceDetails) {
        let bodyData = {
          createdFor: user?._id,
          location: {
            type: "point",
            coordinates: selectedAddress?.location?.coordinates,
          },
          orderType: selectedCategory,
          address: {
            generalLocation: selectedAddress?.generalLocation,
            postalCode: selectedAddress?.postalCode,
            displayAddress: selectedAddress
          },
          formatedAddress: `${selectedAddress?.address?.replace('Singapore', '')}`,
          unitNo: selectedAddress?.unitNo ?? "",
          additionalMessage: additionalComments ?? "",
          preferredStaff: !!selectedPreferredStaff
            ? selectedPreferredStaff
            : [],
          sessions: numberOfsessions,
          discountId: selectedDiscount?.discountId ?? "",
          discountCode: selectedDiscount?.discountCode ?? "",
          TransactionFee: 0,
          svcStartDate: regularServiceArrays[0]?.startDate,
          svcEndDate:
            regularServiceArrays[
              regularServiceArrays?.length - 1
            ]?.endDate,
          serviceArray: regularServiceArrays,
          recurenceRule: recurrenceRule,
          isAllowForNightService:
            recurrenceRule?.timePreference?.includes("Night"),
          serviceDescription: priceDetails?.servicePriceArray?.map(item => `Regular ${item.duration} Hour`),
          serviceSummary: getServiceSummary(analysisArray)
        };
        if (!!secondaryStaff && !selectedPreferredStaff?.length) {
          bodyData.secondaryStaff = secondaryStaff
        }
        dispatch(createNewOrder({ values: bodyData, dispatch: dispatch, navigate: navigate, user: user }));
      }
    }
    else {
      let existingServiceArray = [...selectedProfServiceArray]
      if (professionalServiceAllFilesForUiShow && professionalServiceAllFilesForUiShow?.length) {
        for (let file of professionalServiceAllFilesForUiShow) {
          let uploadedFile = await pushProfilePhotoToS3(file)
          // if (!uploadedFile) {
          for (let service of existingServiceArray) {
            if (service?.serviceId === file?.serviceId) {
              existingServiceArray[existingServiceArray?.findIndex(item => item?.serviceId === file?.serviceId)] = {
                ...existingServiceArray[existingServiceArray?.findIndex(item => item?.serviceId === file?.serviceId)],
                files: existingServiceArray[existingServiceArray?.findIndex(item => item?.serviceId === file?.serviceId)]?.files ? [...existingServiceArray[existingServiceArray?.findIndex(item => item?.serviceId === file?.serviceId)]?.files, `${process.env.REACT_APP_CDN_URL_PATH}/professional_order_data/${file?.name}`] : [`${process.env.REACT_APP_CDN_URL_PATH}/professional_order_data/${file?.name}`]
              }
            }
          }
          // }
        }
      }


      let bodyData = {
        createdFor: user?._id,
        location: {
          type: "point",
          coordinates: selectedAddress?.location?.coordinates,
        },
        orderType: Array.from(new Set(serviceTypes))[0],
        serviceTypes: Array.from(new Set(serviceTypes)),
        address: {
          generalLocation: selectedAddress?.generalLocation,
          postalCode: selectedAddress?.postalCode,
          displayAddress: selectedAddress
        },
        formatedAddress: `${selectedAddress?.address?.replace('Singapore', '')}`,
        unitNo: selectedAddress?.unitNo ?? "",
        additionalMessage: additionalComments ?? "",
        preferredStaff: !!selectedPreferredStaff
          ? selectedPreferredStaff
          : [],
        sessions: numberOfsessions,
        discountId: selectedDiscount?.discountId ?? "",
        discountCode: selectedDiscount?.discountCode ?? "",
        TransactionFee: 0,
        serviceArray: existingServiceArray,
        preferredDates: preferredDates,
        serviceDescription: priceDetails?.servicePriceArray?.map(item => `${item?.priceDetails?.range ? `${item?.priceDetails?.range} Sqft` : item?.priceDetails?.hdbOptions ? `${item?.priceDetails?.hdbOptions} ${item?.priceDetails?.isTeltCovering ? `(Telt Covering)` : ''}` : ''} `),
        serviceSummary: getServiceSummary(analysisArray)
      }
      dispatch(createNewOrder({ values: bodyData, dispatch: dispatch, navigate: navigate, user: user }))
    }
  };
  useEffect(() => {
    if (selectedCategory?.toLowerCase() === 'general') {
      checkPriceDataForGeneralOrder()
    }
    if (selectedCategory?.toLowerCase() === 'regular') {
      checkPriceDataForRegularOrder()
    }
    else if (selectedCategory?.toLowerCase() === 'professional') {
      checkPriceDataForProfessional()
    }

  }, [selectedDiscount])

  useEffect(()=>{
    if(priceDetails?.subtotal <= 0){
      dispatch(setSelectedDiscount({ selectedDiscount: null }))
      setDiscount(null)
}
  },[priceDetails?.subtotal])

  const checkPriceDataForRegularOrder = () => {

    dispatch(checkPrice({
      values: {
        // "createdFor": user?._id,
        "location": {
          "type": "point",
          "coordinates": selectedAddress?.location?.coordinates
        },
        "orderType": selectedCategory,
        "discountId": selectedDiscount?.discountId ?? "",
        "discountCode": selectedDiscount?.discountCode ?? "",
        "serviceArray": regularServiceArrays,
        "isAllowForNightService": recurrenceRule?.timePreference?.includes('Night')
      }
    }))
  }
  const checkPriceDataForProfessional = () => {
    dispatch(checkPrice({
      values: {
        "location": {
          "type": "point",
          "coordinates": selectedAddress?.location?.coordinates
        },
        "discountId": selectedDiscount?.discountId ?? "",
        "discountCode": selectedDiscount?.discountCode ?? "",
        "orderType": 'Professional',
        "serviceArray": selectedProfServiceArray
      }
    }))
  }
  const checkPriceDataForGeneralOrder = () => {
    dispatch(
      checkPrice({
        values: {
          location: {
            type: "point",
            coordinates: selectedAddress?.location?.coordinates,
          },
          orderType: "General",
          discountId: selectedDiscount?.discountId ?? "",
          discountCode: selectedDiscount?.discountCode ?? "",
          isAllowForNightService: recurrenceRule?.timePreference?.includes('Night'),
          serviceArray: selectedService?.map((item, index) => {
            return {
              serviceId: item?._id,
              duration: selectedDuration,
              position: index + 1,
              "staff": "",
              startDate: selectedStartDate,
              endDate: selectedEndDate,
            };
          }),
        },
      })
    );
  };
  const gotoLoginHandler = () => {
    navigate("/login", { state: { gotoJobBoard: true } })
  }
  const gotoPreviousPage = () => {
    if (selectedCategory?.toLowerCase() === 'general' || selectedCategory?.toLowerCase() === 'regular') {
      navigate('/order-booking')
    }
    else {
      navigate("/professional")
    }

  }



  useEffect(() => {
    if (priceDetails?.total) {
      if ((selectedCategory?.toLowerCase() === 'general') || (selectedCategory?.toLowerCase() === 'regular')) {
        dispatch(setAnalysisArray([{
          "subcats": [],
          "id": selectedService[0]?.categoryId?._id,
          "name": selectedService[0]?.categoryId?.name,
          "price": priceDetails?.total,
          "serviceId": selectedService[0]?._id,
          "serviceName": selectedService[0]?.serviceName,
        }]))
      }
      else {

      }
    }
  }, [priceDetails])
  useEffect(() => {
    return () => {
      dispatch(setAnalysisArray([]))
    }
  }, [])

  return (
    <>
      <div className="checkout-pag max-720">
        {selectedCategory?.toLowerCase() === 'professional' ? <ProfessionalBanner /> : <InnerBanner />
        }

        <div className="summ-flex d-block d-lg-flex align-items-center justify-content-between text-center">
          <p>Service Summary</p>
          <button onClick={() => gotoPreviousPage()} className="btn">
            Previous
          </button>
        </div>
        <div className="apply-flex d-block d-lg-flex align-items-center justify-content-between text-center">
          <p>Have a promo code?</p>
          <div className="applycode position-relative">
            <input value={discount ? discount : ""} type="text" placeholder="PROMOCODE" className="form-control" onChange={(e) => setDiscount(e.target.value)} />
            <div className="app-btn cursor-pointer" onClick={checkDiscountCode}> Apply Code </div>
          </div>
        </div>

        <div className="tabel-service-wrap mb-4">
          <div className="tabel-service">
            <div className=" service-header d-flex align-items-center justify-content-between mb-2" >
              <div className="service-name">
                <h6 className="mb-0">Selected Services</h6>
              </div>
              <div className="service-amount service-name">
                <h6 className="mb-0">S$</h6>
              </div>

            </div>

            <div className="service-list-wrap d-flex align-items-center justify-content-between mb-2" style={{ flexFlow: 'column' }}>
              {priceDetails?.servicePriceArray?.map((item, index) => {
                return (
                  <div className={`PriceDetailsDesign`}>

                    <div className="service-l">{item?.name}  {item?.duration && `${item?.duration}hrs`} {item?.priceDetails?.hdbOptions ? item?.priceDetails?.hdbOptions : item?.priceDetails?.range ? `${item?.priceDetails?.range} Sqft` : ''} {item?.packname ? ` (${item?.packname})` : ''}{item?.isTeltCovering === 'yes' ? ` (Telt Covering)` : ''} * {item?.qty}</div>
                    <div className="service-l">{getPriceFormatted(item?.price)} {selectedCategory?.toLowerCase() === 'professional' && !item?.isQouteGiven && ' (To Quote)'}</div>

                  </div>



                )
              })
              }
            </div>
            <div className="service-list-wrap d-flex align-items-center justify-content-between mb-2">
              <div className="service-l">Location surcharge</div>
              <div className="service-l">{getPriceFormatted(priceDetails?.locationSurcharge)}</div>
            </div>
            <div className="service-list-wrap d-flex align-items-center justify-content-between mb-2">
              <div className="service-l">Holiday surcharge</div>
              <div className="service-l">{getPriceFormatted(priceDetails?.holidaySurcharge)}</div>
            </div>

            {priceDetails?.discountAmount ? <div className="service-list-wrap d-flex align-items-center justify-content-between mb-2">
              <div className="service-l">Discount</div>
              <div className="service-l">{getPriceFormatted(priceDetails?.discountAmount) && `-${getPriceFormatted(priceDetails?.discountAmount)} `} {priceDetails?.discountType === 'percentage' ? "%" : ''}</div>
            </div> : null}
            {priceDetails?.customerGroupDiscount ? <div className="service-list-wrap d-flex align-items-center justify-content-between mb-2">
              <div className="service-l">Customer group discount</div>
              <div className="service-l">{getPriceFormatted(priceDetails?.customerGroupDiscount) && `-${getPriceFormatted(priceDetails?.customerGroupDiscount)}`}</div>
            </div> : null}
            <div className="service-list-wrap d-flex align-items-center justify-content-between mb-2">
              <div className="service-l">Sub-total</div>
              <div className="service-l">{getPriceFormatted(priceDetails?.subtotal)}</div>
            </div>
            <div className="service-list-wrap d-flex align-items-center justify-content-between mb-2">
              <div className="service-l">GST {JSON.parse(localStorage.getItem('priceDetails'))?.gstInPercentage}%</div>
              <div className="service-l">{getPriceFormatted(priceDetails?.gstAmount)}</div>
            </div>

            <div className="table-footer">
              <div className="service-list-wrap d-flex align-items-center justify-content-between mb-2">
                <div className="service-l">Cost will be subjected to GST</div>

                <div className="service-l">
                  <b> Total : ${getPriceFormatted(priceDetails?.total)} {priceDetails?.servicePriceArray?.filter(item => !item?.isQouteGiven)?.length ? selectedCategory?.toLowerCase() === 'professional' && ' (To Quote)' : ''}</b>
                </div>
              </div>
            </div>
          </div>
        </div>
        {!user && <><div className="text-center b-btn-w">
          <button onClick={gotoLoginHandler} className=" b-btn">Returning Customer Login  <img src="/assets/images/arrow-w.png" alt="" /></button>
        </div>
          <div className="cus-n">
            New Customer? Complete the form below and create an account upon checkout.
          </div></>}
        {!user && <SignupComp createOrder={createOrder} />}
        {user && <AddressComp selectedCategory={selectedCategory} createOrder={createOrder} />}
      </div>
    </>
  );
};

export default CheckOut;
